import { Flex } from '@chakra-ui/react';
import { AiFillFile } from 'react-icons/ai';
import { useCurrentColors } from '../../../hooks/UseCurrentColors/UseCurrentColors';
import CanopyTooltip from '../../CanopyTooltip/CanopyTooltip';
function FileName({ row, dataKey }: any) {
    const currentColors = useCurrentColors();
    return (
        <Flex width="100%">
            <Flex
                height="14px"
                mr="4px">
                <AiFillFile
                    aria-label="file-name"
                    width="14px"
                    height="14px"
                    color={currentColors.brand['300']}
                />
            </Flex>
            <CanopyTooltip
                label={row[dataKey]}
                minWidth="calc(100% - 18px)">
                {row[dataKey]}
            </CanopyTooltip>
        </Flex>
    );
}
export default FileName;
